<template>
  <div class="import-person-account">
    <w-alert class="ellipsis" show-icon type="error" v-show="errorMessage" style="margin-bottom: 10px;border-radius: 0;" :title="errorMessage"></w-alert>
    <div class="import-person-account-content">
      <template v-if="inputUserInfo">
        <w-form ref="importForm" :model="importForm" label-width="80px" :rules="importRules" label-position="left">
          <w-form-item label="个人账号" prop="userName">
            <w-input size="small" v-model.trim="importForm.userName" placeholder="请输入个人账号" clearable></w-input>
          </w-form-item>
          <w-form-item label="登录密码" prop="password">
            <w-input size="small" :type="inputType" v-model.trim="importForm.password" placeholder="请输入个人账号登录密码" clearable @focus="inputType = 'password'" @change="handleChange"></w-input>
          </w-form-item>
        </w-form>
        <div class="operate-button text-align-right">
          <w-button type="primary" @click.prevent.stop="handlerSubmit()" :disabled="!importForm.userName || !importForm.password">
            确定
          </w-button>
          <w-button type="minor" @click.prevent.stop="handleClose('account')">取消</w-button>
        </div>
      </template>
      <template v-else>
        <p class="explain">个人工程和数据导入到员工账号后，工程和数据将成为企业资产。员工的工程和数据不能导出，工程导入后位于员工空间的【个人空间-{{userName}}】文件夹内。</p>
        <w-form label-width="120px" label-position="left">
          <w-form-item label="选择导入范围">
            <w-checkbox v-model="personalProject">个人工程</w-checkbox>
            <w-checkbox v-model="personalData">个人数据</w-checkbox>
          </w-form-item>
        </w-form>
        <div class="operate-button text-align-right">
          <w-button type="primary" @click.prevent.stop="handlerImport()" :disabled="!personalProject && !personalData">
            导入
          </w-button>
          <w-button type="minor" @click.prevent.stop="handleClose('type')">取消</w-button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import service from '@/assets/service'
import JsEncrypt from 'jsencrypt'
// rsa加密
const encrypt = new JsEncrypt()
const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDd9v+OVxa5ituKgpeyUVHG6oLd15HJsI6UHj7ZcQsrGTJGzA+Gv0LkPwnHBxyqXnaY8gY98KVBGCE/3gfejdT8a9Wx7n7Iu1xPE35WnYzSZ/TuDVzK3bU8HV/EiiVPXEzJQmhmHMwMzUOJJ3+jGkafad/BVs8Pysxdd3uUWkInuQIDAQAB'
export default {
  name: 'ImportPersonalAccount',
  data () {
    // 用户名输入框验证
    const validateUsername = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入个人账号'))
      } else {
        callback()
      }
    }
    // 密码输入框验证
    const validatePassword = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入个人账号登录密码'))
      } else {
        callback()
      }
    }
    return {
      gldUserId: null,
      workspaceId: null,
      inputUserInfo: true, // 是否为用户名、密码表单
      inputType: 'text', // 密码输入框type类型
      importForm: {
        userName: '',
        password: ''
      },
      importRules: {
        userName: [
          {validator: validateUsername, trigger: 'blur'}
        ],
        password: [
          {validator: validatePassword, trigger: 'blur'}
        ]
      },
      errorMessage: '',
      userName: '',
      personalProject: true, // 个人工程
      personalData: true // 个人数据
    }
  },
  methods: {
    // 改变密码输入框的类型
    handleChange (value) {
      if (value === '') {
        this.inputType = 'text'
      }
    },
    // 导入个人账号表单提交
    handlerSubmit () {
      this.$refs.importForm.validate((valid) => {
        if (valid) {
          const {userName, password} = this.importForm
          encrypt.setPublicKey(publicKey)
          let encryptPassword = encrypt.encrypt(password)
          service.user.validateAccount({userName, password: encryptPassword}).then(res => {
            const {code, data = {}, message = ''} = res || {}
            this.errorMessage = ''
            if (code === 200) {
              this.sentLog(100113054, {status: 1})
              const {gldUserId, workspaceId} = data
              this.gldUserId = gldUserId
              this.workspaceId = workspaceId
              this.inputUserInfo = false
              this.userName = userName
              this.$refs.importForm.resetFields()
              // } else if (code === 200002) {
              //   this.errorMessage = message || '广联云用户或密码错误'
              // } else if (code === 200036) {
              //   this.errorMessage = message || '用户已被锁定'
              // } else if (code === 210013) {
              //   this.errorMessage = message || '非个人用户'
            } else {
              this.sentLog(100113054, {status: 2, message})
              message && (this.errorMessage = message)
            }
          }).catch(error => {
            this.errorMessage = error.message
          })
        }
      })
    },
    // 点击导入
    handlerImport () {
      const {personalProject = false, personalData = false, gldUserId, workspaceId, userName} = this
      // 验证个人工程、个人数据最少选择一项
      if (!personalProject && !personalData) {
        this.errorMessage = '个人工程、个人数据最少选择一项'
        return
      } else {
        this.errorMessage = ''
      }
      // 执行导入
      this.importPersonData({personalProject, personalData, gldUserId, workspaceId, userName})
    },
    // 导入个人账号
    importPersonData ({personalProject = false, personalData = false, gldUserId, workspaceId, userName}) {
      const task = []
      const type = []
      if (personalProject) {
        task.push(service.user.importPersonProject({personalUserId: gldUserId, personalWorkspaceId: workspaceId, userName}))
        type.push('personalProject')
      }
      if (personalData) {
        task.push(service.user.importPersonData({importGldUserId: gldUserId, importGldWorkspaceId: workspaceId, importUserName: userName}))
        type.push('personalData')
      }
      this.$message.success('正在导入')
      this.sentLog(100113056, {type})
      Promise.all(task).then(res => {
        //
      }).catch(error => {
        //
      })
      this.handleClose()
    },
    // 关闭弹窗
    handleClose (field = '') {
      // 表单数据重置
      if (field === 'account') {
        this.sentLog(100113055)
        this.$refs.importForm.resetFields()
      } else if (field === 'type') {
        this.sentLog(100113057)
      }
      this.errorMessage = ''
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="less">
  .import-person-account {
    .import-person-account-content {
      padding: 24px;
      .explain {
        font-size: 14px;
        font-weight: 400;
        color: #FA6400;
        line-height: 22px;
        margin: 0 0 24px 0;
      }
      .operate-button {
        padding-top: 14px;
      }
    }

  }
</style>
